import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdatePartnerQuestionnaireRequestSchema,
  TUpdatePartnerQuestionnaireResponseSchema,
} from "./updatePartnerQuestionnaire.schema";

export const updatePartnerQuestionnaire = (axios: IAxiosInstance) => {
  return async (data: TUpdatePartnerQuestionnaireRequestSchema) => {
    const { partner_id, security_documents, ...rest } = data;

    const response = await axios.noRetry.patch<
      IApiResponse<TUpdatePartnerQuestionnaireResponseSchema>
    >(`/api/partners/${partner_id}/questionnaire`, {
      ...rest,
      security_documents,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
